export default __webpack_public_path__ + "static/media/S-013.ccf47bcc.png";